import styled from '@emotion/styled'

export const ContainerAddEmail = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
`

export const MarginWrapper = styled.div`
  margin-bottom: 20px;
`

export const ButtonWrapper = styled.div`
  margin-top: 20px;
  text-align: center;
`
